import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

declare function require(moduleName: string): any;
const { version : appVersion } = require('../../../../package.json');

export const createTranslateLoader = (httpClient: HttpClient) => {
  return new TranslateHttpLoader(httpClient,  '/assets/i18n/', '.json?' + appVersion);
};



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/factories/translate-loader.factory.ts